// extracted by mini-css-extract-plugin
export default {"connector__type":"connector__type__tYu8D","connector__comment":"connector__comment__rgoFV","connector__empty":"connector__empty__rxOG1"};